import { cn } from "@/lib/utils";

/** Marca Lumë: um ponto de luz com halo + wordmark serifado. */
export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <span className="relative inline-flex h-7 w-7 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-gradient-to-br from-glow via-[hsl(320_70%_78%)] to-primary opacity-80 blur-[6px]" />
        <span className="relative h-3.5 w-3.5 rounded-full bg-surface shadow-[0_0_12px_2px_hsl(var(--glow))]" />
      </span>
      {!compact && <span className="font-display text-[1.45rem] leading-none tracking-tight">Lumë</span>}
    </span>
  );
}
